import { render, staticRenderFns } from "./EmbedTopNavigation.vue?vue&type=template&id=1461310c&"
import script from "./EmbedTopNavigation.vue?vue&type=script&lang=js&"
export * from "./EmbedTopNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/krankerl.FFR503Cp8cB3/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1461310c')) {
      api.createRecord('1461310c', component.options)
    } else {
      api.reload('1461310c', component.options)
    }
    module.hot.accept("./EmbedTopNavigation.vue?vue&type=template&id=1461310c&", function () {
      api.rerender('1461310c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation/EmbedTopNavigation.vue"
export default component.exports